module.exports = __webpack_public_path__ + "static/sand-21fecff8280326e823283a335c53f203.png";